import { apiClient } from './client';
import type {
  User,
  LoginRequest,
  RegisterRequest,
  AuthResponse,
  ChangePasswordRequest,
  DeleteAccountRequest,
  TokenVerifyResponse,
} from '@/types';

export const authApi = {
  login: async (data: LoginRequest): Promise<AuthResponse> => {
    const response = await apiClient.post<AuthResponse>('/auth/login', data);
    if (response.success && response.data?.token) {
      apiClient.setToken(response.data.token);
    }
    return response;
  },

  register: async (data: RegisterRequest): Promise<AuthResponse> => {
    return apiClient.post<AuthResponse>('/auth/register', data);
  },

  logout: async (): Promise<{ success: boolean; message: string }> => {
    try {
      const response = await apiClient.post<{ success: boolean; message: string }>('/auth/logout', {});
      return response;
    } finally {
      apiClient.setToken(null);
    }
  },

  getCurrentUser: async (): Promise<{ success: boolean; data: User }> => {
    return apiClient.get<{ success: boolean; data: User }>('/auth/me');
  },

  verifyToken: async (token?: string): Promise<{ success: boolean; data: TokenVerifyResponse }> => {
    if (token) {
      apiClient.setToken(token);
    }
    return apiClient.post<{ success: boolean; data: TokenVerifyResponse }>('/auth/verify-token', {});
  },

  refreshToken: async (): Promise<{ success: boolean; data: { token: string } }> => {
    const response = await apiClient.post<{ success: boolean; data: { token: string } }>('/auth/refresh', {});
    if (response.success && response.data?.token) {
      apiClient.setToken(response.data.token);
    }
    return response;
  },

  changePassword: async (data: ChangePasswordRequest): Promise<{ success: boolean; message: string }> => {
    return apiClient.put<{ success: boolean; message: string }>('/auth/change-password', data);
  },

  deleteAccount: async (data: DeleteAccountRequest): Promise<{ success: boolean; message: string }> => {
    try {
      const response = await apiClient.delete<{ success: boolean; message: string }>('/auth/account', data);
      return response;
    } finally {
      apiClient.setToken(null);
    }
  },
};
